module.exports = __webpack_public_path__ + "img/lock_video2.36f75f44.svg";